<template>
    <div class="d-flex flex-nowrap justify-content-between align-items-center">
        <div class="mr-2">{{ firstTag | truncate(25) }}</div>
        <button class="btn btn-link p-0" v-tooltip:top="document" @click="onDocumentTags()">
            <i class="fas fa-tags fa-lg fa-fw" :data-count="tagCount"></i>
        </button>
    </div>    
</template>

<script>
export default {
    props: {
        document: Object
    },
    computed: {
        tagCount: function() {
            return (this.document && this.document.tags && this.document.tags.length) ? this.document.tags.length : null;
        },
        firstTag: function () {
            return (this.document && this.document.tags && this.document.tags.length) ? this.document.tags[0].tag : null;
        }
    },
    methods: {
        onDocumentTags: function () {
        
            // always using document id for non-historical service forms
            let id = this.document.document_id ?? this.document.id;
            eventHub.$emit('show-document-tags', this.document.client_id, this.document.claim_id, id, this.document.document_type.id, this.document.historical);
        }        
    },
    directives: {
        tooltip: function (el, binding) {

            if ($(el)) { $(el).popover('dispose'); }
            if (binding.value.tags && binding.value.tags.length) {

                $(el).popover({
                    content:  binding.value.tags.map(t => t.tag).join('<br/>'),
                    placement: binding.arg,
                    trigger: 'hover',
                    html: true
                });
            }
        }        
    }    
}
</script>

<style scoped>

    .fas-tags {
        font-size: 1em;        
    }

    .fas[data-count] {
        position: relative;
    }

    .fas[data-count]:after {
        position: absolute;
        top: .1em;
        left: -.05em;
        content: attr(data-count);
        line-height: .7em;
        color: #fff;
        text-align: center;
        min-width: 2em;
        font: bold .5em sans-serif;      
    }
</style>